/* eslint-disable @typescript-eslint/no-explicit-any */
import { useGroupedPages } from '@mercadoni/sinister/dist/cjs/shared/hooks'
import { FC } from 'react'

interface CustomPagesLogicProps {
  Wrapper: FC<any>
  maxItemsInline: number
}

const CustomPagesLogic: FC<CustomPagesLogicProps> = ({
  Wrapper,
  maxItemsInline,
}) => {
  const { groupedPages } = useGroupedPages({
    position: 'header',
  })

  return <Wrapper groupedPages={groupedPages} maxItemsInline={maxItemsInline} />
}

export default CustomPagesLogic
